<template>
  <b-container style="width:600px;">
    <b-card>
      <h3>Check Access Code</h3>
      <br/>
      <b-card-text>
        <b-input-group prepend="Access Code">
          <b-form-input v-model="form.coupon" @keyup.enter="checkCoupon" type="text"></b-form-input>
          <b-input-group-append>
            <b-button variant="success" @click="checkCoupon">Submit
              <b-spinner v-if="isSending" class="m-1" label="Spinning" small/>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <ul class="mt-3">
          <li v-for="error in coupon_errors" :key="error" style="color:red">{{ error }}</li>
        </ul>

        <ul>
          <li v-for="thiscoupon in coupons" :key="thiscoupon.id">
            <a href="#" @click.prevent="selectCoupon(thiscoupon)">{{ thiscoupon.coupon_code }}</a>
          </li>
        </ul>

        <div v-if="coupon">
          <div v-if="coupon.coupon_code && coupon.coupon_code.length < MIN_COUPON_LENGTH" class="text-warning mb-2">
            <b-icon icon="exclamation-triangle" aria-hidden="true"></b-icon>
            FYI: this code is shorter than the {{ MIN_COUPON_LENGTH }}-character minimum and will fail in the Join Flow.
          </div>
          <div>
            <ul v-if="coupon.product.count_unique_emails" class="text-success font-weight-bold" style="list-style-type: none; margin: 0; padding: 0">
              <li>Access Code: {{ coupon.coupon_code }}</li>
              <li>Product: {{ coupon.product.product_code }}</li>
              <li>Usage: {{ combined_uniques.length }}/{{ coupon.max_usage }} emails</li>
              <li v-if="coupon.expires_at">Valid thru: {{ new Date(coupon.expires_at).toLocaleString() }}</li>
            </ul>
            <ul v-else class="text-success font-weight-bold" style="list-style-type: none; margin: 0; padding: 0">
              <li>Access Code: {{ coupon.coupon_code }}</li>
              <li>Product: {{ coupon.product.product_code }}</li>
              <li>Usage: {{ coupon.lti_enrollments.length + coupon.memberships.length }}/{{ coupon.max_usage }} enrollments</li>
              <li v-if="coupon.expires_at">Valid thru: {{ new Date(coupon.expires_at).toLocaleString() }}</li>
            </ul>
          </div>

          <br>

          <b-tabs content-class="mt-3">
              <b-tab title="Enrollments">
                <div class="mb-3">
                  Enrollments ({{ coupon.lti_enrollments.filter(x => x.is_processed).length }}/{{ coupon.lti_enrollments.length }})
                  <div v-if="coupon.lti_enrollments.length">
                    <b-table :bordered="true" :small="true" :items="coupon.lti_enrollments" :fields="lti_fields" thead-class="d-none">
                      <template #cell(email)="data">
                        <a :href="'/course/' + data.item.context_id" v-if="data.item.is_processed" class="text-success font-weight-bold" style="max-width: 350px; word-break: break-word;">{{data.value}}</a>
                        <a :href="'/course/' + data.item.context_id" v-else class="text-muted" style="max-width: 350px; word-break: break-word;">{{ data.value }}</a>
                      </template>
                      <template #cell(updated_at)="data">
                        <div v-if="data.item.is_processed" class="text-success font-weight-bold" style="width: 150px;">{{ data.value }}</div>
                        <div v-else class="text-muted" style="width: 150px;"></div>
                      </template>
                    </b-table>
                  </div>
                </div>
                <div>
                  LTI 1.3 Enrollments ({{ coupon.memberships.filter(x => x.processed_at != nil).length }}/{{ coupon.memberships.length }})
                  <div v-if="coupon.memberships.length">
                    <b-table :bordered="true" :small="true" :items="coupon.memberships" :fields="membership_fields" thead-class="d-none">
                      <template #cell(email)="data" >
                        <a :href="'/activate_course/' + data.item.token" v-if="data.item.processed_at != nil" class="text-success font-weight-bold" style="max-width: 350px; word-break: break-word;">{{data.value}}</a>
                        <a :href="'/activate_course/' + data.item.token" v-else class="text-muted" style="max-width: 350px; word-break: break-word;">{{ data.value }}</a>
                      </template>
                      <template #cell(processed_at)="data">
                        <div v-if="data.item.processed_at != nil" class="text-success font-weight-bold" style="width: 150px;">{{ data.value }}</div>
                        <div v-else class="text-muted" style="width: 150px;"></div>
                      </template>
                    </b-table>
                  </div>
                </div>
              </b-tab>
              <b-tab title="Emails" v-if="coupon.lti_enrollments.length || coupon.memberships.length">
                <div class="mb-3" v-if="coupon.lti_enrollments.length">
                  Enrollments
                  <div>
                    <ul>
                      <li style="list-style: none;" v-for="enrollment in uniques" :key="enrollment.id">
                        <span>{{ enrollment.email }}</span>
                    </li>
                  </ul>
                  </div>
                </div>
                <div v-if="coupon.memberships.length">
                  LTI 1.3 Enrollments
                  <div>
                    <ul>
                      <li style="list-style: none;" v-for="enrollment in enrollment_uniques" :key="enrollment.id">
                        <span>{{ enrollment.email }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </b-tab>
            </b-tabs>

        </div>
      </b-card-text>
    </b-card>
  </b-container>
</template>

<script>
import {checkCoupon} from "@/utils/twa-api";
import {MIN_COUPON_LENGTH} from "@/utils/constants";

export default {
  data() {
    return {
      MIN_COUPON_LENGTH,
      form: {
        coupon: this.$route.params.code
      },
      isSending: false,
      coupon_errors: [],
      coupon: null,
      coupons: [],
      lti_fields: [
        { key: "email", label: "Email" },
        { key: "updated_at", label: "Processed At", formatter: this.formatDate }
      ],
      membership_fields: [
        { key: "email", label: "Email" },
        { key: "processed_at", label: "Processed At", formatter: this.formatDate}
      ]
    }
  },
  computed: {
    uniques() {
      let unique = (value, index, self) => {
        let findIndex = (element) => element.email === value.email;
        return self.findIndex(findIndex) === index;
      }
      return this.coupon.lti_enrollments.filter(unique)
    },
    enrollment_uniques() {
        let unique = (value, index, self) => {
          let findIndex = (element) => element.email === value.email;
          return self.findIndex(findIndex) === index;
        }
        return this.coupon.memberships.filter(unique)
    },
    combined_uniques() {
      let allEmails = [...this.coupon.lti_enrollments, ...this.coupon.memberships];
      let unique = (value, index, self) => {
        return self.findIndex(e => e.email === value.email) === index;
      }
      return allEmails.filter(unique);
    }
  },
  methods: {
    handleLoginEvent(data) {
      this.isAuthenticated = data.loggedIn
      this.profile = data.profile
    },
    async checkCoupon() {
      this.isSending = true
      this.coupon = null
      this.coupons = null
      this.coupon_errors = []
      try {
        this.coupons = await checkCoupon(this.form.coupon)
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.coupon_errors.push("Access code not found");
        } else if (error.response && error.response.status === 500) {
          this.coupon_errors.push("Internal Server Error");
        } else {
          console.log(error)
        }
      }
      this.isSending = false
    },
    formatDate(value) {
      const date = new Date(value);
      let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      let dateString = date.toLocaleString('en-US', options);
      return dateString;
    },
    selectCoupon(coupon) {
      this.coupon = coupon
      this.coupon.lti_enrollments = this.coupon.lti_enrollments.sort((a, b) => a.email > b.email ? 1 : -1)
    }
  }
}
</script>